import { Link } from "react-router-dom";
import Logo from "../../../assets/images/svg/logo/utivacolored.svg";

const columns = [
  {
    title: "Explore",
    links: [
      { title: "Programs", url: "/school" },
      { title: "Global MBA", url: "/mba" },
      { title: "Hire talent", url: "/hire" },
    ],
  },
  {
    title: "Company",
    links: [
      { title: "Our story", url: "/about-us" },
      { title: "Culture", url: "/about-us" },
      { title: "Careers", url: "/careers" },
      { title: "Our partners", url: "/partners" },
      { title: "Business network", url: "/ubn" },
    ],
  },
  {
    title: "Resources & Contact",
    links: [
      { title: "Blog", url: "/blog" },
      { title: "Events", url: "/events" },
      { title: "Podcast", url: "/podcast" },
      { title: "info@utiva.io", url: "mailto:info@utiva.io" },
    ],
  },
];

const AboutFooter = () => {
  return (
    <footer className="bg-hire-tint-blue py-16 md:py-20 px-4">
      <div className="container mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 pb-10 mb-8 border-b border-hire-line">
          <div className="lg:col-span-1">
            <img className="h-7 w-auto mb-5" src={Logo} alt="Utiva" />
            <p className="text-gray font-poppins text-sm leading-relaxed max-w-xs">
              Build practical skills. Discover capable talent. Support global
              teams through one connected platform.
            </p>
          </div>

          {columns.map((column) => (
            <div key={column.title}>
              <h3 className="font-poppins font-bold text-primary text-base mb-4">
                {column.title}
              </h3>
              <ul className="grid gap-3">
                {column.links.map((link) => (
                  <li key={link.title}>
                    {link.url.includes("mailto") ? (
                      <a
                        href={link.url}
                        className="font-poppins text-gray text-sm hover:text-primary transition-colors"
                      >
                        {link.title}
                      </a>
                    ) : (
                      <Link
                        to={link.url}
                        className="font-poppins text-gray text-sm hover:text-primary transition-colors"
                      >
                        {link.title}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <p className="font-poppins text-gray text-sm">
          © 2026 Utiva. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default AboutFooter;
